import { MetalPlanPageSection } from '@/page/domain/MetalPlanPageSection';

export const gold80PageData: Partial<MetalPlanPageSection> = {
  initialBanner: {
    visible: true,
    title: 'Covered California',
    subtitle: 'Gold is Golden',
    subtitleColor: 'text-yellow',
  },
  highlightSection: {
    visible: true,
    content: '<p>The Gold plan shines with its <b>$o deductible</b>, reasonable copayments, and a price tag that is softer than the top of the line Platinum. Typical services will range from a $19-$80 copay. Should you ever need to visit the hospital or have a lot of medical needs, the most you would need to pay for covered services in a year would be the out-of-pocket maximum <span class="whitespace-nowrap">(OOP Max)</span>. See details for each plan.</p>',
    imageUrl: '/assets/img/bg/family_hfc.webp'
  },
  metalPlansSection: {
    visible: true,
    title: 'What Types of Health Plans are Available',
    redirectUrl: '/covered-california/plans'
  },
  textSection: {
    visible: false,
    title: 'Is The Covered California Gold Plan Right for Me?',
    subContent: [
      `<p><b>If you don't like deductibles, then let's talk more.</b> Not everyone has extra savings lying around to cover a deductible, but would rather pay a little more per month for a plan with copayments they can afford. If you are the kind of person who doesn't want a <b>plan with a deductible</b>, i.e. the
        Minimum Coverage, Bronze or Silver plan, and you don't like the price tag of the more expensive Platinum plan. then the Gold may be just right for you.</p>`,
      `<p>You need <b>specific medical services</b>. Advanced imaging such as an MRI, CT. or PET can be pricey on a plan with a deductible. If you anticipate the need for these services, have a scheduled surgery, or are at <b>high risk for occasional hospital visits</b> then this plan should be up for serious
        consideration.</p>`,
      '<p>If you <b>only frequent the doctor\'s office</b>, typically take generic drugs, and are not exposed to risk that takes you to the hospital often, then you may want to look closer at the Silver Plan to see which plan is going to be to your advantage. Remember, if you can pay the deductible on the Silver plan if needed, then the savings in premium per month is <b>extra money</b> in your pocket.</p>',
    ]
  },
  googleReviewsSection: {
    visible: true,
    title: 'Customer Reviews',
    imageUrl: '/assets/img/bg/guys_working.webp'
  },
  certifiedBanner: {
    visible: true,
  },
  twoColumnSection: {
    visible: true,
    title: 'A Little More to Think About',
    subtitle: '<p>Let\'s talk about PPO\'s and how this would affect a Gold plan.</p>',
    content: `<p>If you enrolled on a <b>Gold PPO plan</b>, then the benefits described with affiliated copayments only apply when your doctor or medical provider is "In Network" or a "Participating Provider.”</p>
    <br>
    <p>If you were to visit a "Non-Participating Provider" a deductible may be required. Plus your cost for the services may be higher. oftentimes <b>a charge of 50%</b> (see plan coverage benefit details).</p>
    <br>
    <p>In addition, you would have a much <b>higher out-of- pocket maximum</b>, in the event of a "worst case scenario". So it is extremely important that you are aware of who is a "Participating Provider" and who is not before receiving your services.</p>
    <br>
    <p>If your reason for enrolling in the PPO is to have access to that “Non-Participating Provider" who is an expert in their field, then just make sure you are <b>aware of your portion of the cost</b>, so you are not caught by surprise. For additional information, contact the carrier.</p>`,
    imageUrl: '/assets/img/bg/father_and_son.webp'
  },
  finalBanner: {
    visible: true,
    title: 'A LITTLE MORE TO THINK ABOUT',
    subtitle: 'Let\'s talk about PPO\'s and how this would affect a <b>Gold Plan</b>',
    imageUrl: '/assets/img/bg/family_and_doctor_fadedx.png',
    redirectUrl: '/covered-california/plans/hmo-or-ppo'
  }
};
